<bit-dialog #dialog background="alt">
  <span bitDialogTitle>{{ "generatorHistory" | i18n }}</span>
  <ng-container bitDialogContent>
    @if (hasHistory$ | async) {
      <bit-credential-generator-history [account]="account$ | async" />
    } @else {
      <bit-empty-credential-history style="display: contents" />
    }
  </ng-container>
  <ng-container bitDialogFooter>
    <button
      [disabled]="!(hasHistory$ | async)"
      bitButton
      type="submit"
      buttonType="primary"
      (click)="clear()"
    >
      {{ "clearHistory" | i18n }}
    </button>
  </ng-container>
</bit-dialog>
